import React from 'react';
// import Rx from 'rxjs';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/observable/from';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/timer';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/pairwise';
import 'rxjs/add/operator/concatMap';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/delayWhen';
import 'rxjs/add/operator/bufferWhen';
import 'rxjs/add/operator/debounceTime';

import CONFIG from '../../Config';
import Message from './Message';
import InputBase from './InputBase';
import FixedInputBase from './FixedInputBase';
import MobileInputBase from './MobileInputBase';
import InputBox from './InputBox';
import ScrollButton from './ScrollButton';
import KeywordSelector from '../keywords/KeywordSelector';

import Logger from '../../../../../UmiCore/src/Logger';
import ChatUtils from '../utils/ChatUtils';
import DateUtils from '../utils/DateUtils';

// Test purposes
// import sampleMessages from './sample-messages';

class Messenger extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile: props.isMobile,
      avatar_shape: props.avatar_shape,
      logo: props.logo,
      brand_name: props.brand_name,
      tagline: props.tagline,
      keywords: props.keywords,
      branding: props.branding,
      typing: props.typing,
      widget_hide_header: props.widget_hide_header,
      messagesList: [],
      agentsInfo: {},
      loadingOldMessages: false,
      disabled: true,
      input_motion: true,
      input_type: null,
      field: null,
      field_type: null,
      buttons: null,
      payloads: null,
      extra: null,
      backButton: this.showBackButton(),
      fixed: false,
    };

    this.ee = props.ee;
    this.messagesContainer = null;
    this.moreMessagesButton = null;
    this.setupListeners();
    this.getAgentsInfo();

    this.scrollTopFixer = null;
    this.scrollFixer = null;
    this.scrollAuto = true;

    this.mobileHA = true;
    this.animationsDelay = 500;
    this.typingState$ = new BehaviorSubject(false);
    this.engageIndex = 0;
    this.initialChatFlag = true;
    this.endEngageFlag = false;
    this.endFlowFlag = false;
    this.restarting = false;

    this.inputAnimation$ = new Subject();

    // Temporal chat data
    window.temp_data = {
      name: '',
      phone: '',
      email: '',
      // Add fields
    };
  }

  setupListeners() {
    // MESSAGES BUFFER
    const queueMessagesRender$ = new Subject();
    queueMessagesRender$
      .startWith(null)
      .pairwise(queueMessagesRender$)
      .concatMap((messages) => {
        const prevMessage = messages[0];
        const message = messages[1];

        if (message === null || this.restarting) {
          this.endFlowFlag = true;
          return Observable.of(null).delay(0);
        }
        
        message.typing = false;

        if (this.hasRoleType(prevMessage, 'error')) {
          this.endFlowFlag = false;
          return Observable.of(null).delay(0);
        }

        /**
         * Los mensajes cuyo previo era de tipo engage aparecen al instante.
         */
        if (this.hasRoleType(prevMessage, 'engage')) {
          
          Logger.append(
            `${DateUtils.format(new Date(), 'HH:mm:ss.ff')}: Previous message is "engage"`,
            `landbot.messages[${message.key}]`,
          );

          message.key = prevMessage.key;
          message.typingDelay = 0;
          this.endFlowFlag = false;
          return Observable.of(message).delay(0);

        /**
         * Los mensajes de tipo engage aparecen al instante
         */
        } else if (this.hasRoleType(message, 'engage')) {

          Logger.append(
            `${DateUtils.format(new Date(), 'HH:mm:ss.ff')}: Current message is "engage"`,
            `landbot.messages[${message.key}]`
          );

          message.typing = this.typingState$;
          message.typingDelay = 20000;
          this.endFlowFlag = false;
          return Observable.of(message).delay(0);

        /**
         * Los mensajes de bot, si typing === true y no ha sido activado
         * el flag de salto de group, aparecen al finalizar el flujo del 
         * mensaje anterior.
         */
        } else if (message.samurai < 0 && this.props.typing === true) {
          message.typing = this.typingState$;
          message.typingDelay = this.getTypingDelay(prevMessage, message).typing;
          
          // El primer mensaje aparece sin delay
          if (prevMessage === null) {

            Logger.append(
              `${DateUtils.format(new Date(), 'HH:mm:ss.ff')}: First group message`,
              `landbot.messages[${message.key}]`
            );

            this.endFlowFlag = false;
            return Observable.of(message).delay(0);
          }

          // Mensajes que no tienen que esperar el fin de flujo
          if (this.hasRoleType(prevMessage, 'end-flow')) {

            Logger.append(
              `${DateUtils.format(new Date(), 'HH:mm:ss.ff')}: Previous message has role type "end-flow", so current launches`,
              `landbot.messages[${message.key}]`
            );

            this.endFlowFlag = false;
            return Observable.of(message).delay(0);
          }

          if (this.endFlowFlag) {

            Logger.append(
              `${DateUtils.format(new Date(), 'HH:mm:ss.ff')}: "end-flow" flag was enabled, so it launches`,
              `landbot.messages[${message.key}]`
            );

            this.endFlowFlag = false;
            return Observable.of(message).delay(0);
          }

          Logger.append(
            `${DateUtils.format(new Date(), 'HH:mm:ss.ff')}: Message awaits for "end-flow" event and launches`,
            `landbot.messages[${message.key}]`
          );

          // Mensajes a la espera de un evento de fin de flujo
          return Observable
            .of(message).delayWhen(
              () => Observable.fromEvent(this.ee, 'hu-lb-message-flow-end')
            );

        /**
         * El resto de mensajes aparecen tras el delay propio de animaciones
         */
        } else {

          Logger.append(
            `${DateUtils.format(new Date(), 'HH:mm:ss.ff')}: Message awaits for animations timing and launches`,
            `landbot.messages[${message.key}]`
          );

          // return Observable.of(message).delay(0);
          return Observable.of(message).delay(this.animationsDelay);
        }
      })
      .subscribe((message) => {
        if (message === null)
          return;

        const msg = this.processedMessage(message);
        if (msg.author === 'brand') { // Only brand messages are rendered

          // Fetch agent data if not in store
          const agentID = msg.data.samurai;
          if (agentID > 0) {
            if (!this.state.agentsInfo[agentID])
              this.ee.emit('hu-query-get-agent', agentID);
          }

          Logger.append(
            `${DateUtils.format(new Date(), 'HH:mm:ss.ff')}: Message render`,
            `landbot.messages[${msg.data.key}]`
          );
          // console.debug(`%cLandbot debug: rendering message <${msg.data.key}> ${DateUtils.format(new Date(), 'HH:mm:ss.ff')}`, 'color:blue');
          const animate = true;
          this.appendMessage(msg, animate);
        }
      });
    
    // timeSpan determina el tiempo necesario de espera para asegurar la llegada de mensajes ordenados
    const timeSpan = 1250;
    const reception$ = Observable.fromEvent(this.ee, 'hu-receive-message');
    reception$.subscribe({
      next: v => {
        if (v)
          Logger
            .append(
              `${DateUtils.format(new Date(), 'HH:mm:ss.ff')}: Message received`,
              `landbot.messages[${v.key}]`
            )
            .append(
              v,
              `landbot.messages[${v.key}]`
            );
        // console.debug(`%cLandbot debug: received new message <${v.key}> ${DateUtils.format(new Date(), 'HH:mm:ss.ff')}`, 'color:blue')
        // console.debug(v)
      }
    });

    // MESSAGES RECEIVED FROM FIREBASE
    const messageReception$ = reception$
      .bufferWhen(() => {
        return Observable.fromEvent(this.ee, 'hu-receive-message')
          .debounceTime(timeSpan) // Resetea el tiempo cada vez que llega uno nuevo
      })
      .subscribe((data) => {
        // Mensajes ordenados
        const messages = data
          .filter(m => m)
          .filter(m => m.samurai !== undefined)
          .filter(this.messagesFilter)
          // .filter(m => !this.getReferralFilter(m))
          .sort((a, b) => a.timestamp - b.timestamp)
          .map(m => JSON.parse(JSON.stringify(m)));

        for (let i = 0; i < messages.length; i++) {
          let msg = messages[i];
          if (msg !== null && i === messages.length - 1) {
            // This is the last message in a group of incoming messages
            msg.role = this.addRoleType(msg, 'end-flow');

            Logger.append(
              `${DateUtils.format(new Date(), 'HH:mm:ss.ff')}: Message defined as "end-flow"`,
              `landbot.messages[${msg.key}]`
            );

            // Proactive message can't be referral
            if (msg.type === 'referral' && messages[i - 1]) {
              if (messages[i - 1].samurai !== undefined) {
                // En este punto, el objeto mensaje puede contener más objetos, de modo que necesita
                // ser convertido en un objeto "puro"
                const { extra, key, message, role, samurai, type } = messages[i - 1];
                const _msg = { data: { extra, key, message, role, samurai, type } };
                this.ee.emit('hu-receive-last-group-message', _msg);

                Logger.append(
                  `${DateUtils.format(new Date(), 'HH:mm:ss.ff')}: Previous message emitted as last group message`,
                  `landbot.messages[${key}]`
                );
              } else 
                Logger.append(
                  `${DateUtils.format(new Date(), 'HH:mm:ss.ff')}: Message is referral but none is emitted as last group message`,
                  `landbot.messages[${msg.key}]`,
                  'warn'
                );

            } else {  // En este punto sigue siendo un objeto "puro"
              this.ee.emit('hu-receive-last-group-message', this.processedMessage(msg));

              Logger.append(
                `${DateUtils.format(new Date(), 'HH:mm:ss.ff')}: Message emitted as last group message`,
                `landbot.messages[${msg.key}]`
              );
            }
          }
          queueMessagesRender$.next(msg);
        }
      });
    
    // SENT MESSAGES RENDERED IMMEDIATELY
    const sending$ = Observable.fromEvent(this.ee, 'hu-sending-message')
      .subscribe((message) => {
        if (message.render === false)
          return;
        // this.addRoleType(message, 'end-flow');
        const animate = true;
        this.disableInput(() => {
          this.appendMessage(this.processedMessage(message), animate);

          // ENGAGE PROTOCOL --------------------------------------------
          // Protocolo empleado en la conexión inicial a firebase,
          // donde se simula un mensaje de typing durante dicha conexión.
          // if (!this.state.fixed) {
          //   // queueMessagesRender$.next(null);
          //   this.ee.emit('hu-receive-message', {
          //     key: `engage_${this.engageIndex++}`,
          //     type: 'text',
          //     message: CONFIG.text.error,
          //     samurai: -1,
          //     role: ['engage'],
          //     extra: { hide_textbox: true },
          //   });
          // }
          // END ENGAGE PROTOCOL ----------------------------------------
        });
      });

    this.ee.on('hu-receive-ghost-message', (message) => {
      const animate = true;
      this.appendMessage(this.processedMessage(message), animate);
    });

    this.ee.on('hu-initial-chat', (messages) => {
      if (this.initialChatFlag) {
        this.initialChatFlag = false;
        const _messages = messages
          .filter(this.messagesFilter)
          .map(this.processedMessage);
        this.renderInitialChat(_messages);
        this.onMessagesChunk(_messages);
      }
    });

    this.ee.on('hu-reset-chat', () => {
      this.ee.emit('hu-lb-message-flow-end');
      this.initialChatFlag = false;
      this.restarting = true;
      // Null resets messages animations flow
      queueMessagesRender$.next(null);

      const receiverReady$ = Observable.fromEvent(this.ee, 'hu-lb-receiver-ready');
      const initialChat$ = Observable.fromEvent(this.ee, 'hu-initial-chat');
      const newMessage$ = Observable.fromEvent(this.ee, 'hu-receive-message');

      // Receive initial chat
      Observable
        .merge(receiverReady$, initialChat$)
        .distinctUntilChanged()
        .pairwise()
        .first()
        .subscribe({
          next: (v) => {
            if (this.restarting) {  // Race with "Receive new message"
              this.restarting = false;
              const messages = v
                .filter(w => w)[0]
                .filter(this.messagesFilter)
                .map(this.processedMessage);
              this.renderInitialChat(messages);
              this.onMessagesChunk(messages);
            }
          }
        });

      // Receive new message
      Observable
        .merge(receiverReady$, newMessage$)
        .distinctUntilChanged()
        .pairwise()
        .first()
        .subscribe({
          next: (v) => {
            if (this.restarting) {  // Race with "Receive initial chat"
              this.restarting = false;
            }
          }
        });

      // Hide Old chat button
      if (this.moreMessagesButton)
        Velocity(
          this.moreMessagesButton,
          { opacity: 0 },
          { duration: 500 }
        );
      this.setState({ disabled: true }, () => {
        this.scrollBottom(350, 'top');
        this.inputAnimation$.next('input_out');
      });
      setTimeout(() => {
        this.setState({
          messagesList: [],
          hasOldMessages: false,
        }, () => this.ee.emit('hu-lb-receiver-ready'));
      }, 600);
      // Velocity(
      //   document.querySelectorAll('#hu-messages-container .hu-message'),
      //   { opacity: 0.5 },
      //   { duration: 500, complete: () => {
      //     this.setState({
      //       messagesList: [],
      //     }, () => {
      //       console.log(this.state.messagesList);
            
      //     });
      //   }}
      // );
    })

    this.ee.on('hu-old-chat', (messages) => {
      this.concatOldMessages(
        messages
          .filter(this.messagesFilter)
          .map(this.processedMessage)
      );
    });

    // BRAND MESSAGE ANIMATION FLOW
    this.brandMessageAnimation$ = new Subject();
    this.brandMessageAnimation$ = this.brandMessageAnimation$.concatMap((message) => {
      return Observable.from([
        'avatar_in',
        'bubble_left_in',
        'typing_on',
        'typing_off',
        'bubble_resize',
        'input_enable',
        'flow_end',
      ])
        .concatMap((step) => {
          switch (step) {
            case 'avatar_in':
              this.scrollBottom(250);
              return Observable.of(step).delayWhen(() => Observable.merge(
                Observable.fromEvent(this.ee, 'hu-lb-avatar-translation-end'),
                Observable.timer(250)
              )).first();
            case 'bubble_left_in':
              return Observable.of(step).delayWhen(() => Observable.merge(
                Observable.fromEvent(this.ee, 'hu-lb-bubble-in'),
                Observable.timer(250) // Verificado
              )).first();
            case 'typing_on':
              /////// TYPING ///////
              /**
               * Un mensaje con typing puede o no tener typing según su
               * función o condiciones externas
               */
              if (message.typing) {
                if (this.hasRoleType(message, 'engage')) {
                  this.typingState$.next({ key: message.key, state: message.typingDelay });

                  // El flag de fin de engage indica que el mensaje real ya ha sido renderizado
                  if (this.endEngageFlag) {
                    Logger.append(
                      `${DateUtils.format(new Date(), 'HH:mm:ss.ff')}: End Engage Flag was True. Disabling typing...`,
                      `landbot.messages[${message.key}]`
                    );

                    this.endEngageFlag = false;
                    return Observable.of(step).delay(0);
                  } else {
                    Logger.append(
                      `${DateUtils.format(new Date(), 'HH:mm:ss.ff')}: Typing enabled till timer || engage-end event received`,
                      `landbot.messages[${message.key}]`
                    );

                    return Observable.of(step)
                      .delayWhen(() => Observable.merge(
                        Observable.timer(message.typingDelay),
                        // Observable.fromEvent(this.ee, 'hu-lb-key-arrowdown')
                        Observable.fromEvent(this.ee, 'hu-lb-engage-end')
                      ));
                  }
                }

                if (this.props.typing) {
                  Logger.append(
                    `${DateUtils.format(new Date(), 'HH:mm:ss.ff')}: Typing enabled`,
                    `landbot.messages[${message.key}]`
                  );

                  this.typingState$.next({ key: message.key, state: message.typingDelay });
                  return Observable.of(step)
                    .delayWhen(() => Observable.merge(
                      Observable.timer(message.typingDelay),
                      Observable.fromEvent(this.ee, 'hu-lb-key-arrowdown')
                    ));
                }

                return Observable.of(step).delay(0);
              
              /**
               * Mensajes sin typing
               */
              } else {
                Logger.append(
                  `${DateUtils.format(new Date(), 'HH:mm:ss.ff')}: Typing disabled`,
                  `landbot.messages[${message.key}]`
                );

                this.typingState$.next({ key: message.key, state: false });
                return Observable.of(step).delay(0);
              }
            case 'typing_off':
              this.endEngageFlag = false;
              this.typingState$.next({ key: message.key, state: false });
              return Observable.of(step).delay(0);
            case 'bubble_resize':
              return Observable.of(step).delayWhen(() => Observable.merge(
                Observable.fromEvent(this.ee, 'hu-lb-bubble-resize-end'),
                Observable.timer(0)
              )).first();
            case 'input_enable':
              this.inputAnimation$.next('input_enable');
              return Observable.of(step).delayWhen(() => Observable.merge(
                Observable.fromEvent(this.ee, 'hu-lb-input-resize-end'),
                Observable.timer(0)
              )).first();
            case 'flow_end':
              this.ee.emit('hu-lb-message-flow-end');
              return Observable.of(step).delay(0);
            default:
              return Observable.of(step).delay(0);
          }
        });
    });

    // USER MESSAGE ANIMATION FLOW
    this.userMessageAnimation$ = new Subject();
    this.userMessageAnimation$ = this.userMessageAnimation$.concatMap((message) => {
      return Observable.from([
        'input_out',
        'bubble_right_in',
        'bubble_resize',
        'flow_end',
      ])
        .concatMap((step) => {
          switch (step) {
            case 'input_out':
              this.inputAnimation$.next('input_out');
              return Observable.of(step).delay(0);
            case 'bubble_right_in':
              return Observable.of(step).delayWhen(() => Observable.merge(
                Observable.fromEvent(this.ee, 'hu-lb-bubble-in'),
                Observable.timer(350) // En realidad este tiempo es el de input_out
              )).first();
            case 'bubble_resize':
              return Observable.of(step).delayWhen(() => Observable.merge(
                Observable.fromEvent(this.ee, 'hu-lb-bubble-resize-end'),
                Observable.timer(350)
              )).first();
            case 'flow_end':
              // ENGAGE PROTOCOL --------------------------------------------
              if (!this.state.fixed) {
                setTimeout(() => {
                  queueMessagesRender$.next(null);
                  queueMessagesRender$.next({
                    key: `engage_${this.engageIndex++}`,
                    type: 'text',
                    message: CONFIG.text.error,
                    samurai: -1,
                    role: ['engage', 'end-flow'],
                    extra: { hide_textbox: true },
                  });
                }, 500);
              }
              // ENGAGE PROTOCOL --------------------------------------------
              this.ee.emit('hu-lb-message-flow-end');
              return Observable.of(step).delay(0);
            default:
              return Observable.of(step).delay(0);
          }
        });
    });

    // this.ee.on('hu-remove-message', (messagesInfo) => {
    //   messagesInfo.messages.forEach((message) => {
    //     this.removeMessage(message);
    //   });
    // });

    this.ee.on('hu-get-stored-agents', (agentsData) => {
      this.setState({
        agentsInfo: agentsData,
      });
    });

    this.ee.on('hu-get-agent', (agentInfo) => {
      const { agentsInfo } = this.state;
      const _agentsInfo = JSON.parse(JSON.stringify(agentsInfo));
      _agentsInfo[agentInfo.samurai] = {
        name: agentInfo.name,
        avatar: agentInfo.avatar,
      };
      this.setState({
        agentsInfo: _agentsInfo,
      });
    });

    // this.ee.on('hu-scroll-button-click', () => {
    //   this.onScrollButtonClick();
    // });

    this.ee.on('hu-lb-engage-end', () => {
      this.endEngageFlag = true;
    });

    this.ee.on('hu-error-sending-message', () => {
      this.ee.emit('hu-receive-message', {
        key: ChatUtils.randomKey(20),
        type: 'text',
        message: CONFIG.text.error,
        samurai: -1,
        role: ['error', 'end-flow'],
        extra: { hide_textbox: true, typing: false },
      });
    });

    // NOT USED
    // this.ee.on('hu-lb-temp-data', ({ field, value }) => {
    //   temp_data[field] = value;
    // });
  }

  componentDidMount() {
    this.ee.emit('hu-landbot-ready');
  }

  hasRoleType(msg, type) {
    if (!msg)
      return false;
    const _role = msg.role || [];
    try {
      if (typeof type === 'string')
        return _role.indexOf(type) > -1;
      // else  // Array
      //   return
    } catch(e) {
      return false;
    }
  }

  addRoleType(msg, type) {
    const _role = msg.role || [];
    try {
      if (typeof type === 'string')
        return _role.indexOf(type) > -1 ? _role : _role.concat(type);
      else  // Array
        return _role.concat(type.filter(t => _role.indexOf(t) === -1));
    } catch(e) {
      return _role;
    }
  }

  removeRoleType(msg, type) {
    const index = msg.role.indexOf(type);
    index > -1 ? msg.role.splice(index, 1) : null;
  }

  isExtraWelcome(data) {
    try {
      return !!data.extra.welcome;
    } catch(e) {
      return false;
    }
  }

  getTypingDelay(prevMessage, message) {
    let typing = 0;
    // Desactivación individual
    if (!this.isTyping(message)) {
      typing = 0;
    // Primer mensaje de bot
    } else if (prevMessage === null || prevMessage.samurai === undefined || this.hasRoleType(prevMessage, 'end-flow'))
      typing = 100;
    // Resto de mensajes
    else {
      const text = prevMessage.type === 'dialog'
        ? (prevMessage.title ? prevMessage.title : ' ')
        : (prevMessage.message ? prevMessage.message : ' ');
      const words = text.replace(/\s+/g, ' ').split(' ').length;
      typing = Math.min(200 * words, 1500); // 5 sec maximum
    }
    let currDelay = prevMessage ? (prevMessage.typingDelay ? prevMessage.typingDelay : 0) : 0;
    return { typing, currDelay };
  }

  getAgentsInfo() {
    this.ee.emit('hu-query-stored-agents');
  }

  isTyping(data) {
    let _isTyping = true;
    let _data = data.extra || {};
    if (_data)
      _isTyping = (typeof _data.typing === 'boolean') ? _data.typing : true;
    return _isTyping;
  }

  userMoveScroll(e) {
    Velocity( this.messagesContainer, 'stop', { mobileHA: this.mobileHA } );
    let scrollPosition = this.messagesContainer.scrollHeight - this.messagesContainer.clientHeight;
    if (this.messagesContainer.scrollTop >= scrollPosition - 30 )
      this.scrollAuto = true;
    else
      this.scrollAuto = false;
  }

  scrollBottom(tspan = 0, direction = 'bottom') {
    if (this.scrollAuto) {
      Velocity( this.messagesContainer, 'stop', { mobileHA: this.mobileHA } );
      Velocity(
        direction === 'top' ? this.scrollTopFixer : this.scrollFixer,
        'scroll',
        {
          duration: tspan,
          container: this.messagesContainer,
          mobileHA: this.mobileHA,
        },
      );
    }
  }

  showBackButton() {
    const { keywords } = this.props;
    let result = false;
    for (let k in keywords)
      if (keywords[k] === 'back')
        result = true;
    return result;
  }

  processedMessage(message) {
    return {
      key: message.key,
      author: message.samurai !== undefined ? 'brand' : 'user',
      data: message,  // All message data coming from firebase
      message_id: message.message_id,
    };
  }

  messagesFilter(message) {
    return ['text', 'referral', 'dialog', 'menu', 'image', 'multiple_images', 'iframe'].indexOf(message.type) > -1;
  }

  appendMessage(message, animate = false) {
    let messagesList = this.state.messagesList.slice();
    message.animate = animate;
    let lastMessage = messagesList[messagesList.length - 1];
    let engageReplacement = false;

    // Aplicar reordenación
    if (lastMessage)
      if (lastMessage.timestamp > message.timestamp) {
        // Una vez aplicada reordenación, podemos reducir la espera a 1seg
        
      }

    if (lastMessage) {
      if (this.hasRoleType(lastMessage.data, 'engage')) {
        // Last message replacement
        messagesList[messagesList.length - 1] = message;
        engageReplacement = true;
      } else
        messagesList.push(message); 
    } else
      messagesList.push(message);

    if (message.data.samurai === undefined) { // No input changes
      this.setState({
        messagesList: messagesList,
      });

      Logger.append(
        `${DateUtils.format(new Date(), 'HH:mm:ss.ff')}: [${message.data.key}] User message => No input changes`,
        `landbot.input`
      );

    } else if (message.data.samurai >= 0) { // Fixed text input (assigned agent)
      this.setState({
        messagesList: messagesList,
        disabled: false,
        input_motion: true,
        input_type: 'text', 
        fixed: true,
      }, () => {
        ChatUtils.disableInput();
      });

      Logger.append(
        `${DateUtils.format(new Date(), 'HH:mm:ss.ff')}: [${message.data.key}] Agent message => Input fixed`,
        `landbot.input`
      );

    } else {  // Input changes
      let state = {};
      let disabled = true;
      const fixed = this.getExtraTextareaFixed(message.data);
      if (fixed) {  // Fixed from extra
        state = {
          messagesList: messagesList,
          disabled: false,
          input_motion: true,
          input_type: 'text', 
          fixed: true,
        };

        Logger.append(
          `${DateUtils.format(new Date(), 'HH:mm:ss.ff')}: [${message.data.key}] Bot message => Input fixed`,
          `landbot.input`
        );

      } else if (this.getReferralFilter(message.data)) {
        // Cuando se recibe un referral pero en realidad está oculto porque se encuentra
        // en plan starter+, éste machaca las opciones de input. En este caso las mantiene.
        disabled = this.state.disabled;
        state = {
          messagesList: messagesList,
          backButton: false,
        };

        Logger.append(
          `${DateUtils.format(new Date(), 'HH:mm:ss.ff')}: [${message.data.key}] Bot message => (Referral) No input changes`,
          `landbot.input`
        );

      } else {  // Default behavior
        disabled = this.getDisabledInput(message);
        state = {
          messagesList: messagesList,
          disabled: disabled,
          input_motion: disabled ? false : true,
          input_type: this.getInputType(message.data),
          field: this.getInputField(message.data),
          field_type: this.getFieldType(message.data),
          buttons: message.data.buttons,
          payloads: message.data.payloads,
          extra: message.data.extra,
          backButton: (
            !this.hasRoleType(message.data, 'welcome') && 
            !this.hasRoleType(message.data, 'revisit') &&
            !this.isExtraWelcome(message.data) &&
            message.data.type !== 'referral'
          ) && 
            this.showBackButton(),
          fixed: false,
        };
      }
      this.setState(state, () => {
        if (!disabled && !fixed) {
          if (engageReplacement) {
            this.inputAnimation$.next('input_enable');
          }
          ChatUtils.enableInput();
        }
      });

      Logger.append(
        `${DateUtils.format(new Date(), 'HH:mm:ss.ff')}: [${message.data.key}] Bot message => Input ${this.getInputType(message.data)}`,
        `landbot.input`
      );
    }
  }

  renderInitialChat(messages) {
    if (messages.length === 0)
      return;

    let hasOldMessages = messages.length >= 20;
    const lastMessage = messages[messages.length - 1];

    /**
     * En lugar de utilizar lastMessage, intentaré utilizar el último mensaje
     * escrito por brand. Si es de bot, nada, pero si es de agente, se 
     * establece un input fixed.
     */
    const lastBrandMessage = this.getLastBrandMessage(messages);

    if ( // Fixed text input (assigned agent)
      lastBrandMessage.data.samurai >= 0 || 
      this.getExtraTextareaFixed(lastBrandMessage.data)
    )
      this.setState({
        messagesList: messages,
        hasOldMessages: hasOldMessages,
        disabled: false,
        input_motion: true,
        input_type: 'text', 
        fixed: true,
      }, () => {
        ChatUtils.disableInput();
        setTimeout(() => {
          this.inputAnimation$.next('input_enable');
        }, 100);
      });
    else if (lastMessage.data.samurai === undefined) // No input changes
      this.setState({
        messagesList: messages,
        hasOldMessages: hasOldMessages,
      });
    else {  // Input changes
      let state = {};
      let disabled = true;
      const fixed = this.getExtraTextareaFixed(lastMessage.data);
      if (fixed)  // Fixed from extra
        state = {
          messagesList: messages,
          hasOldMessages: hasOldMessages,
          disabled: false,
          input_motion: true,
          input_type: 'text', 
          fixed: true,
        };
      else {  // Default behavior
        disabled = this.getDisabledInput(lastMessage);
        state = {
          messagesList: messages,
          hasOldMessages: hasOldMessages,
          disabled: disabled,
          input_type: this.getInputType(lastMessage.data),
          field: this.getInputField(lastMessage.data),
          field_type: this.getFieldType(lastMessage.data),
          buttons: lastMessage.data.buttons,
          payloads: lastMessage.data.payloads,
          extra: lastMessage.data.extra,
          backButton: (
            !this.hasRoleType(lastMessage.data, 'welcome') && 
            !this.hasRoleType(lastMessage.data, 'revisit') &&
            !this.isExtraWelcome(lastMessage.data) &&
            lastMessage.data.type !== 'referral'
          ) && 
            this.showBackButton(),
          fixed: false,
        };
      }
      this.setState(state, () => {
        if (!disabled) {
          ChatUtils.enableInput();
          setTimeout(() => {
            this.inputAnimation$.next('input_enable');
          }, 100);
        } else {
          setTimeout(() => {
            this.scrollBottom(350);
          }, 100);
        }
      });
    }
  }

  concatOldMessages(messages) {
    const messagesList = this.state.messagesList.slice();
    if (messages.length !== 0) {
      this.setState({
        messagesList: messages.concat(messagesList),
        hasOldMessages: true,
        loadingOldMessages: false,
      });
    } else {
      this.setState({
        hasOldMessages: false,
        loadingOldMessages: false,
      });
    }
  }

  /**
   * Returns last brand message from a list of messages
   * @param {Array} messages - Processed messages
   */
  getLastBrandMessage(messages) {
    let i = 1;
    let lastBrandMessage = messages[messages.length - i];
    while (
      (lastBrandMessage.data.samurai === undefined &&
      i < messages.length - 1) ||
      (lastBrandMessage.data.samurai !== undefined &&
      this.getReferralFilter(lastBrandMessage.data))
    ) {
      i += 1;
      lastBrandMessage = messages[messages.length - i];
    }
    return lastBrandMessage;
  }

  onMessagesChunk(messages) {
    const msg = messages[messages.length - 1];
    const _msg = this.getLastBrandMessage(messages);
    if (!msg)
      return;
    if (msg.data.samurai !== undefined) { // brand message
      Logger
        .append(
          `Message emitted as last group message ${DateUtils.format(new Date(), 'HH:mm:ss.ff')}`,
          `landbot.messages[${_msg.data.key}]`,
        )
        .append(
          _msg,
          `landbot.messages[${_msg.data.key}]`,
        );
      this.ee.emit('hu-receive-last-group-message', _msg);
    } else {  // user message: Used to detect humanTakeOver
      Logger
        .append(
          `Message emitted as last brand message ${DateUtils.format(new Date(), 'HH:mm:ss.ff')}`,
          `landbot.messages[${_msg.data.key}]`,
        )
        .append(
          msg,
          `landbot.messages[${_msg.data.key}]`,
        );
      this.ee.emit('hu-receive-last-brand-message', _msg);
    }
  }

  removeMessage() { // TODO
    let messagesList = this.state.messagesList.slice();
    this.setState({
      messagesList: messagesList,
    });
  }

  queryOldMessages() {
    if (!this.state.loadingOldMessages) {
      this.ee.emit('hu-query-old-messages');
      this.setState({
        loadingOldMessages: true,
      });
    }
  }

  getInputType(data) {
    const isMenu = ['dialog', 'menu'].indexOf(data.type) > -1;
    const isReferral = this.getInputReferral(data);
    let field = this.getInputField(data);
    let multi = this.getInputMulti(data);
    let hideTextbox = this.getInputHidetextbox(data);
    let input_type = 'none';
    if (isReferral)
      input_type = 'referral';
    else if (isMenu)
      input_type = multi ? 'multi' : 'menu';
    else if (field)
      input_type = 'field';
    else if (!hideTextbox)
      input_type = 'text';
    return input_type;
  }

  getReferralFilter(data) { // true if referral is disabled, false if visible
    try {
      return data.type === 'referral' && data.extra.referral === false;
    } catch(e) {
      return false;
    }
  }

  getInputReferral(data) {
    try {
      return data.type === 'referral' && data.extra.referral !== false;
    } catch(e) {
      return false;
    }
  }

  getInputField(data) {
    try {
      return data.extra.textarea.field;
    } catch(e) {
      return false;
    }
  }

  getFieldType(data) {
    try {
      return data.extra.textarea.type;
    } catch(e) {
      return null;
    }
  }

  getInputMulti(data) {
    try {
      return data.extra.buttons.multi;
    } catch(e) {
      return false;
    }
  }

  getInputHidetextbox(data) {
    try {
      return data.extra.hide_textbox;
    } catch(e) {
      return false;
    }
  }

  getExtraTextareaFixed(data) {
    try {
      return data.extra.textarea.fixed;
    } catch(e) {
      return false;
    }
  }

  disableInput(callback) {
    if (!this.state.fixed) {
      ChatUtils.disableInput();
      this.setState({
        disabled: true,
      }, callback);
    } else {
      callback();
    }
  }

  getDisabledInput(message) {
    const disabled = this.getInputType(message.data) === 'none' || message.data.samurai === undefined;
    return disabled;
  }

  render() {
    const ee = this.ee;
    const { 
      isMobile, 
      avatar_shape, 
      logo, 
      brand_name, 
      tagline, 
      keywords, 
      branding, 
      typing,
      widget_hide_header,
    } = this.props;

    const {
      messagesList,
      agentsInfo,
      hasOldMessages,
      loadingOldMessages,
      disabled,
      input_motion,
      input_type,
      field,
      field_type,
      buttons,
      payloads,
      extra,
      backButton,
      fixed,
    } = this.state;
    const disableInput = this.disableInput.bind(this);
    const sendMessage = ChatUtils.sendMessage.bind(this);
    const lastMessage = messagesList[messagesList.length - 1];

    return (
      <div id="hu-messenger" className={`${disabled ? ' hu-no-keywords' : ''}${branding ? '' : ' hu-no-referral'}${fixed ? ' hu-input-fixed' : ''}`}>
        <div
          id="hu-messages-container"
          onTouchMove={(e)=>{this.userMoveScroll(e)}}
          onWheel={(e)=>{this.userMoveScroll(e)}}
          ref={(elem) => {this.messagesContainer = elem;}}
        >
        <div 
          id="scroll-top-fixer" 
          ref={(elem) => {this.scrollTopFixer = elem;}}
        ></div>

         { !widget_hide_header &&
            <div id="hu-header-mobile" className="hu-a-center">
              <img class="hu-header-logo" src={logo} alt=""/>
              <h1 class="hu-header-brand_name hu-w-bold hu-s-20 hu-color_header-text">
                {brand_name}
              </h1>
              <p class="hu-header-tagline hu-s-14 hu-x-ellipsis hu-color_header-text" title="Get more leads using chatbots ��">
                {tagline}
              </p>
            </div>
         }
          <div className="hu-messages-wrapper">
            <div className="hu-old-chat">
              { hasOldMessages &&
                <button 
                  className="more-messages hu-color_contrast hu-border-color_contrast hu-s-15"
                  ref={(elem) => {this.moreMessagesButton = elem;}}
                  onClick={this.queryOldMessages.bind(this)}
                  tabIndex={-1}
                >
                  <span className={`more-messages-text`}>Load more...</span>
                </button>
              }
            </div>

            { messagesList.map((message, index, list) => {
              if (message.message_id)
                return <Message
                  avatar_shape={avatar_shape}
                  key={message.message_id}
                  author={message.author}
                  data={message.data}
                  animate={message.animate}
                  list={list}
                  agentsInfo={agentsInfo}
                  isMobile={isMobile}
                  mobileHA={this.mobileHA}
                  ee={ee}
                  brandMessageAnimation$={this.brandMessageAnimation$}
                  userMessageAnimation$={this.userMessageAnimation$}
                  scrollBottom={this.scrollBottom.bind(this)}
                />
              else 
                return <Message 
                  avatar_shape={avatar_shape}
                  key={message.key}
                  author={message.author}
                  data={message.data}
                  animate={message.animate}
                  list={list}
                  agentsInfo={agentsInfo}
                  isMobile={isMobile}
                  mobileHA={this.mobileHA}
                  ee={ee}
                  brandMessageAnimation$={this.brandMessageAnimation$}
                  userMessageAnimation$={this.userMessageAnimation$}
                  scrollBottom={this.scrollBottom.bind(this)}
                />
              }
            )}

            {/* { !fixed && */}
              <InputBase 
                ee={this.ee} 
                disabled={disabled}
                mobileHA={this.mobileHA}
                inputAnimation$={this.inputAnimation$}
                scrollBottom={this.scrollBottom.bind(this)}
              >
                { !fixed &&
                  <InputBox
                    disabled={disabled}
                    input_motion={input_motion}
                    sendMessage={sendMessage}
                    input_type={input_type}
                    field={field}
                    field_type={field_type}
                    buttons={buttons}
                    payloads={payloads}
                    extra={extra}
                    backButton={backButton}
                    emoji={'hu-message-input'}
                    lastMessage={lastMessage}
                    ee={ee}
                  />
                }
              </InputBase>
            {/* } */}
            
            <div 
              id="scroll-bottom-fixer" 
              ref={(elem) => {this.scrollFixer = elem;}}
            ></div>
          </div>
        </div>

        {/* <ScrollButton
          ee={ee}
          clickHandler={this.onScrollButtonClick.bind(this)}
        /> */}
        
        { fixed &&
          <FixedInputBase
            ee={this.ee} 
            disabled={disabled}
            mobileHA={this.mobileHA}
            inputAnimation$={this.inputAnimation$}
            scrollBottom={this.scrollBottom.bind(this)}
          >
            {/* Este input es visible cuando se tiene un agente asignado.
              * Siempre está visible hasta recibir un mensaje de bot.
              */}
            <InputBox
              disabled={disabled}
              input_motion={input_motion}
              sendMessage={sendMessage}
              input_type={input_type}
              backButton={false}
              fixed={fixed}
              emoji={'hu-footer-input-fixed'}
              ee={ee}
            />
          </FixedInputBase>
        }

        <MobileInputBase
          ee={this.ee} 
          disabled={disabled}
          mobileHA={this.mobileHA}
          inputAnimation$={this.inputAnimation$}
          scrollBottom={this.scrollBottom.bind(this)}
        >
          {/* Este input sólo es visible en dispositivos móviles.
            * Su input/textbox es una réplica exacta del que aparece dentro del 
            * contenedor de mensajes en pantalla grande, que no es visible en móviles.
            */}
            {/* <ScrollButton
              ee={this.ee}
              //clickHandler={this.onScrollButtonClick.bind(this)}
            /> */}
          {/* { isMobile && */}
            <InputBox
              brand_name={brand_name}
              branding={branding}
              keywords={keywords}
              typing={typing}
              disabled={disabled}
              input_motion={input_motion}
              sendMessage={sendMessage}
              input_type={input_type}
              field={field}
              field_type={field_type}
              buttons={buttons}
              payloads={payloads}
              extra={extra}
              backButton={fixed ? false : backButton}
              fixed={fixed}
              lastMessage={lastMessage}
              ee={ee}
            />
          {/* } */}
        </MobileInputBase>

        <div id="hu-msn-sandbox"></div>
        <div id="hu-input-sandbox"></div>
        <div id="hu-mobile-input-sandbox"></div>
      </div>
    )
  }
}

export default Messenger;


// WEBPACK FOOTER //
// ./app/js/components/messenger/Messenger.js